import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ContactFormComponent } from './contact-form.component';
import { TranslateModule } from '@ngx-translate/core';
import { SystemButtonModule, SystemInputSetModule, SystemToastModule } from '@app/shared/ui-components';
import { LoadingSpinnerModule } from '@app/shared';

@NgModule({
  declarations: [ContactFormComponent],
  exports: [ContactFormComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    SystemButtonModule,
    SystemInputSetModule,
    LoadingSpinnerModule,
    SystemToastModule,
  ],
})
export class ContactFormModule {}
